import React, { useState } from 'react'
import { TabsContainer, TabsWrapper, Tab, ContentWrapper, Content, Label, Description, ImageWrapper, Img } from './TabsElements'

const Tabs = ({ info }) => {
    const [active, setActive] = useState('ingredient')

    const handleClick = (e) => {
        setActive(e.target.value)
    }

    return (
        <TabsContainer>
            <TabsWrapper>
                <Tab onClick={handleClick} value="ingredient" active={active === "ingredient"}>Ingredients</Tab>
                <Tab onClick={handleClick} value="info" active={active === "info"}>Additional Info</Tab>
                <Tab onClick={handleClick} value="measurement" active={active === "measurement"}>Measurement</Tab>
            </TabsWrapper>
            <ContentWrapper>
                <Content active={active === "ingredient"}>
                    <Label>What Inside</Label>
                    <Description>{info.ingredients ? info.ingredients : '-'}</Description>
                    <Label>Allergens</Label>
                    <Description>{info.allergens ? info.allergens : '-'}</Description>
                </Content>
                <Content active={active === "info"}>
                    <Label>Estimate Weight</Label>
                    <Description>{info.weight ? info.weight : '-'}</Description>
                    <Label>Layer</Label>
                    <Description>{info.layers ? info.layers : '-'}</Description>
                    <Label>Cake Shape</Label>
                    <Description>{info.shape ? info.shape : '-'}</Description>
                    <Label>Serving Size</Label>
                    <Description>{info.serving ? info.serving : '-'}</Description>
                    <Label>Shelf Life</Label>
                    <Description>{info.shelf ? info.shelf : '-'}</Description>
                </Content>
                <Content active={active === "measurement"}>
                    <ImageWrapper>
                        <Img
                            src={info.measurement}
                            alt="Measurement"
                        />
                    </ImageWrapper>
                </Content>
            </ContentWrapper>
        </TabsContainer>
    )
}

export default Tabs
